import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthDistrictsGuide,
	GetHealthDistrictsGuideModel,
	GetHealthDistrictsGuideParams,
} from 'domain/usecases/private/guide-flow/medical-guide/get-districts';

export class RemoteGetHealthDistrictsGuide implements GetHealthDistrictsGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthDistrictsGuideModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthDistrictsGuideParams): Promise<GetHealthDistrictsGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
